<template>
  <div class="align-items-stretch d-md-flex w-100">
    <div class="card text-center card-square w-100 mb-2">
      <div class="card-body card-body--dense">
        <h5
          class="card-title title-square"
          :style="mobileClass()?'margin: 0px;':''"
        >
          <strong>{{ title ? title : '--' }}</strong>
        </h5>
        <!-- <p
          class="card-text text-square"
          :style="this.mobileClass()?'margin: 0px;':''"
        >
          {{ body }}
        </p> -->
        <p class="m-0 p-0 mini-text-square">
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'Hour',
    props: {
        body: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            required: true,
        },
    },
    methods: {
        mobileClass() {
            const width = window.innerWidth;
            if (width > 400) {
                return false;
            }
            return true;
        },
    },
};
</script>

<style lang="scss">
.card-square {
  // border-width: 2px !important;
  // border-radius: 0.6rem !important;
  // border-color: #cbcbcb !important;
  border: none !important;
  box-shadow: 0 0 10px rgba(black, 0.1);
}
.title-square {
  font-size: 26px;
}
.text-square {
  font-size: 13px;
}
.mini-text-square {
  font-size: 11px;
}
.card-body--dense{
  padding: 0.8rem !important;
}
</style>
